"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
var _interopRequireWildcard = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireWildcard.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/DateRange.js";
function DateRange(_ref) {
  var field = _ref.field,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    start = _useState2[0],
    setStart = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    end = _useState4[0],
    setEnd = _useState4[1];
  function _onChange(startDate, endDate) {
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    var where = {};
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString()
    };
    onChange(where);
  }
  function _onChangeStart(date) {
    setStart(date.toISOString().slice(0, 10));
    _onChange(date, new Date(end));
  }
  function _onChangeEnd(date) {
    setEnd(date.toISOString().slice(0, 10));
    _onChange(new Date(start), date);
  }
  _react["default"].useEffect(function () {
    var date = new Date();
    setStart(date.toISOString().slice(0, 10));
    setEnd(date.toISOString().slice(0, 10));
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control form-control-sm shadow-none w-auto rounded-0",
    value: start,
    onInput: function onInput(e) {
      return _onChangeStart(e.target.valueAsDate);
    },
    type: "date",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control form-control-sm shadow-none w-auto rounded-0 rounded-end",
    value: end,
    onInput: function onInput(e) {
      return _onChangeEnd(e.target.valueAsDate);
    },
    type: "date",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 13
    }
  }));
}
var _default = DateRange;
exports["default"] = _default;